import styled from "@emotion/styled";

const CoverImage = `
  .tpd-image-preview-mode-container {
    height: 100%;
  }

  .tpd-image-preview-mode-container img {
    height: 100%;
     object-fit: cover;
  }
`;

export const ContainerDiv = styled.div`
  background-color: transparent;
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  margin: auto;
  width: 100%;
  height: 100%;
  z-index: 999;
`;
